import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Pagination } from '../../components/pagination'
import { NavBar } from '../../components/navbar'
import { Footer } from '../../components/footer'

import { InputContainer} from '../signup'
import { Button } from '../../components/button'
import { PopularNigerianaData } from '../../popularnigerianadata'
import { BoxContainer, TextContainer, ImageContainer } from "../components/../../components/postCard"

import { useDispatch, useSelector } from 'react-redux'
import { getRecentNigeriana } from '../../pages/features/public/publicSlice'

import { getResourceCategory } from '../../pages/features/resourcecategory/resourcecategorySlice'

// import { CardsContainer } from '../../pages/landingpage/components/popularnigeriana'

const NigerianaPublications = () => {


    const dispatch = useDispatch()
    
    const { publicResources, publicStatus} = useSelector(state => state.publicResources);
    const { resourceCategory, resourceCategoryStatus} = useSelector(state => state.resourceCategory);


    useEffect(() => {

        dispatch(getResourceCategory());

    }, [resourceCategoryStatus]);

    useEffect(() => {

        dispatch(getRecentNigeriana());

    }, [publicStatus, dispatch]);

  return (
    <Container>
        <NavBar />
        <InnerContainer>
            <h2>Nigeriana Publications</h2>
            <p>Below are Nigerian publications made in Nigeria </p>

            <NewsSearch>

                <div>
                    <form>
                        <h5>Search Nigeriana Publications</h5>
                        <InputContainer>
                            
                            <input type="search" placeholder='Title' />
                        </InputContainer>

                        <InputContainer>
                            
                            <input type="search" placeholder='Author' />
                        </InputContainer>

                        <InputContainer>
                            
                            <input type="search" placeholder='Keyword' />
                        </InputContainer>
                        
                        <InputContainer>
                            
                            <input type="search" placeholder='NLN Code' />
                        </InputContainer>


                        <InputContainer>
                            
                            <select name="" id="">
                                <option value="">Select a category</option>

                                {
                                resourceCategory.map((category) => {
                                return(
                                    <option value={category.resourceCategoryId} key={category.resourceCategoryId}>{category.resourceCategoryName} </option>
                                )
                                    })
                                }
                                
                            </select>
                        </InputContainer>

                        {/* <InputContainer>
                            <label htmlFor="date">Date</label>
                            
                            <DateInput>
                                <input name='date' type="search" placeholder='Between year' />
                                <input name='date' type="search" placeholder='And year' />
                            </DateInput>
                            
                        </InputContainer> */}

                        <ButtonContainer>
                            <Button filled bgColor={'#2A870E'} noIcon text={'Search'} />
                            {/* <Button filled bgColor={'#fa8072'} noIcon text={'Reset'} /> */}
                        </ButtonContainer>

                    </form>

                    <div>

                        <h5>Sort Search Result</h5>
                            <InputContainer>
                                <label htmlFor="date">Sort by year</label>
                                <DateInput>
                                    <input name='date' type="search" placeholder='From' />
                                    <input name='date' type="search" placeholder='To' />
                                </DateInput>
                            </InputContainer>

                            <InputContainer>
                                <label htmlFor="date">Sort Alphabetically</label>
                                <select name="" id="">
                                    <option value="">A-Z</option>
                                    <option value="">Z-A</option>
                                </select>
                            
                            </InputContainer>
                    </div>

                </div>

                

                <Publications>
                {
                publicResources.map((nigeriana) => {
                    return(

                        <CardsContainer key={nigeriana.resourceId}>
                            <BoxContainer>
                            <LinkToDetails to={`/nigeriana/resource/${nigeriana.resourceNlnCode}`} >
                                <ImageContainer src={nigeriana.resourceImage} />
                                <TextContainer>
                                    <h5>
                                    {nigeriana.resourceTitle}
                                    </h5>
                                    <small>by
                                     {nigeriana.resourceAuthor}
                                    </small>
                                </TextContainer>
                                </LinkToDetails>
                            </BoxContainer>
                        </CardsContainer>
                    )
                })
            }
                </Publications>
            </NewsSearch>
            <Pagination />
        </InnerContainer>
        


        
    </Container>
  )
}

const Container = styled.section`
    width: 100%;
    max-width: 1250%;
    margin: 0 auto;
    
    
`
export const InnerContainer = styled.div`
    width: 80%;
    max-width: 1250px;
    display: flex;
    margin: 0 auto;
    padding-top: 30px;
    justify-content: center;
    flex-direction: column;

   

    &  select{
        background-color: inherit;
        border: 2px solid #D0D5DD;
        border-radius: 4px;
        height: 32px;
        padding: 0 10px;

        & > option{
            height: 30px;
        }
    }

    @media screen and (max-width: 600px){
        width: 90%;

    }
`

export const NewsSearch = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 70px;

    @media screen and (max-width: 600px){
        flex-direction: column;
        padding-top: 40px;
    }

    & > div{
        width: 30%;
        /* position: fixed; */

        @media screen and (max-width: 600px){
            width: 100%;
        }
    

    & form{
        /* flex: 1; */
        padding-bottom: 50px;
        /* width: 100%; */
        position: sticky;

        
        
    }

}
`

export const Publications = styled.section`
    /* flex: 2; */
    width: 65%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 20px;

    @media screen and (max-width: 600px){
        width: 100%;
        justify-content: center;
    }
`

export const DateInput = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 5px;
    width: inherit;
    justify-content: space-between;

    & input{
        width: 47%;
    }
`
const LinkToDetails = styled(Link)`
    text-decoration: none;
    color: #000;
`


export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 20px;
    width: 80%;
    height: 44px;
    justify-content: space-between;

    @media screen and (max-width: 600px){
        width: 45%;
    }
`
const CardsContainer = styled.div`
    padding-bottom: 20px;
`


export default NigerianaPublications